import * as Sentry from '@sentry/browser';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SentryService {
  public setUserId(userId: string): void {
    Sentry.setUser({ id: userId });
  }

  public setOperator(operator: string): void {
    Sentry.setTag('operator', operator);
  }

  public captureException<T extends Record<string, unknown>>(
    error: Error,
    context?: string,
    data?: T,
  ): void {
    Sentry.captureException(error, {
      extra: {
        context,
        ...data,
      },
    });
  }

  public addBreadcrumb(name: string, params: object = {}): void {
    Sentry.addBreadcrumb({
      category: 'log',
      message: name,
      data: params,
      level: 'info',
    });
  }
}
